import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {    
    async getLeadsComBoards(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("leads/access/listarLeadsDataComBoard", dados, { timeout: 60000 });
        if (!Array.isArray(data)) throw new Error('Resposta inválida ao consultar leads');
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};